import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import { StyledButton } from '../../styles/StyledButtons';
import { Palette } from 'Palette';

interface ImpersonateQrPanelProps {
  url: string;
  secondsLeft: number;
  expired: boolean;
  busy: boolean;
  onRegenerate: () => void;
}

function formatCountdown(seconds: number): string {
  const s = Math.max(0, seconds);
  return `${Math.floor(s / 60)}:${(s % 60).toString().padStart(2, '0')}`;
}

export function ImpersonateQrPanel({
  url,
  secondsLeft,
  expired,
  busy,
  onRegenerate,
}: ImpersonateQrPanelProps) {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2} pt={1}>
      <Typography variant="body2" color="text.secondary" textAlign="center">
        Scan with your phone. You must be signed in to the admin site as yourself on that phone.
      </Typography>
      <Box
        sx={{
          p: 2,
          bgcolor: '#ffffff',
          borderRadius: 2,
          border: `1px solid ${Palette.default.border}`,
          boxShadow: 1,
          opacity: expired ? 0.3 : 1,
        }}
      >
        <QRCodeSVG
          value={url}
          size={200}
          bgColor="#ffffff"
          fgColor={Palette.default.text}
          level="M"
        />
      </Box>
      <Typography variant="caption" color={expired ? 'error' : 'text.secondary'}>
        {expired ? 'Expired — generate a new code' : `Expires in ${formatCountdown(secondsLeft)}`}
      </Typography>
      <StyledButton
        variant={expired ? 'contained' : 'outlined'}
        onClick={onRegenerate}
        disabled={busy}
        startIcon={busy ? <CircularProgress size={16} /> : undefined}
      >
        Regenerate code
      </StyledButton>
    </Box>
  );
}

export default ImpersonateQrPanel;
